import React, {useEffect, useState} from 'react';
import TitleBar from "../../components/popUp/TitleBar";
import Table from "react-bootstrap/Table";
import {getDisabilityStatus} from "../../api/apiClient";
import AxcBadge from "../../components/common/AxcBadge";
import BootstrapTable from "react-bootstrap/Table";

/* 대시보드 - 플랫폼 - 장애 현황 */
const DisabilityStatus = ({
                              openLayerHandler,
                              propAtdrcId
                          }) => {
    /* 장애 현황 - table data */
    const [disabilityStatusList, setDisabilityStatusList] = useState([]);

    const getDisabilityStatusList = async (atdrcId) => {
        let resp;
        resp = await getDisabilityStatus(atdrcId);

        return resp;
    };

    const [stTimeRefresher, setTimeRefresher] = useState(null);
    const [stRefreshSeed, setRefreshSeed] = useState(0);

    useEffect(() => {
        getDisabilityStatusList(propAtdrcId)
            .then((response) => {
                setDisabilityStatusList(response.data.data.alarmsList);
            });

        let timeInterval = setInterval(updateCycleSeed, 10000);
        setTimeRefresher(timeInterval);

        return () => {
            clearInterval(stTimeRefresher);
        }
    }, []);

    useEffect(() => {
        getDisabilityStatusList(propAtdrcId)
            .then((response) => {
                setDisabilityStatusList(response.data.data.alarmsList);
            });
    }, [propAtdrcId, stRefreshSeed])

    const updateCycleSeed = () => {
        let rand = Math.random();
        setRefreshSeed(rand);
    }

    const updateCycle = () => {
        getDisabilityStatusList(propAtdrcId).then(res => {
            setDisabilityStatusList(res.data.data.alarmsList);
        })
    };


    return (
        <div className={"content-container"}>
            <TitleBar title={"실시간 장애 현황"}/>
            <div className={"table-responsive text-nowrap px-3"}>
                <BootstrapTable hover className={"table text-center"}>
                    <thead className={"table-head text-secondary"}>
                    <tr className={"text-start"}>
                        <th className={"col"}>등급</th>
                        <th className={"col"}>발생시간</th>
                        <th className={"col"}>장애이벤트</th>
                        {/*<th className={"col"}>상태</th>*/}
                        {/*<th className={"col"}>발생유형</th>*/}
                        {/*<th className={"col"}>자치구</th>*/}
                        <th className={"col"}>발생위치</th>
                    </tr>
                    </thead>
                    <tbody className={"table-body text-white text-start"}>
                    {
                        Array.isArray(disabilityStatusList) ?
                            (disabilityStatusList.map((elem, idx) => {
                                return (
                                    <tr key={idx}>
                                        <td>
                                            <AxcBadge
                                                propInput={elem.serius_level_nm}
                                                propDangerText={'Critical'}
                                                propWarningText={'Major'}
                                                propMinorWarningText={'Minor'}
                                            />
                                        </td>
                                        <td>{elem.ocrn_dt_str}</td>
                                        <td className={"column-title"} data-id={elem.cause_id}
                                            // onClick={(e) => {
                                            //   openPopup(elem.lc, e.target.dataset.id);
                                            // }}
                                        >{elem.cause_nm}
                                        </td>
                                        {/*<td>{elem.sttus_nm}</td>*/}
                                        {/*<td>{elem.lc_knd_nm}</td>*/}
                                        {/*<td>{elem.atdrc_nm}</td>*/}
                                        <td>{elem.mssage}</td>
                                    </tr>
                                );
                            })) : ('')
                    }
                    </tbody>
                </BootstrapTable>
            </div>
        </div>
    );
};

export default DisabilityStatus;
